var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtracurriculars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 12.25V11.0833C9.33329 10.4645 9.08746 9.871 8.64987 9.43342C8.21229 8.99583 7.6188 8.75 6.99996 8.75H3.49996C2.88112 8.75 2.28763 8.99583 1.85004 9.43342C1.41246 9.871 1.16663 10.4645 1.16663 11.0833V12.25",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24996 6.41667C6.53862 6.41667 7.58329 5.372 7.58329 4.08333C7.58329 2.79467 6.53862 1.75 5.24996 1.75C3.96129 1.75 2.91663 2.79467 2.91663 4.08333C2.91663 5.372 3.96129 6.41667 5.24996 6.41667Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 12.2499V11.0832C12.833 10.5662 12.6609 10.064 12.3442 9.65537C12.0274 9.24677 11.5839 8.95493 11.0834 8.82568",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 1.82568C9.83528 1.95419 10.2801 2.24609 10.5978 2.65536C10.9155 3.06464 11.0879 3.568 11.0879 4.0861C11.0879 4.6042 10.9155 5.10756 10.5978 5.51684C10.2801 5.92611 9.83528 6.21801 9.33337 6.34652",
    stroke: "#1D4ED8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtracurriculars);
export default __webpack_public_path__ + "static/media/Extracurriculars.96ba9bfc7ca90e1d95e3486f70338d9a.svg";
export { ForwardRef as ReactComponent };